import type { KpiTrend } from '../types/voip';

/** % change vs the previous equivalent period */
export const kpiTrends: Record<'today' | '7d' | '30d', KpiTrend> = {
  today: { talkSeconds: 3.2, outbound: 4.5, inbound: 2.8, missed: -6.0, answerRate: 0.9, totalCalls: 3.9 },
  '7d': { talkSeconds: 8.4, outbound: 12.1, inbound: 5.7, missed: -14.2, answerRate: 2.1, totalCalls: 12 },
  '30d': { talkSeconds: 5.1, outbound: 7.3, inbound: 4.2, missed: -9.8, answerRate: 1.4, totalCalls: 6.4 },
};
